import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';

@Component({
  selector: 'app-unlock-chapter-dialog',
  templateUrl: './unlock-chapter-dialog.component.html',
  styleUrls: ['./unlock-chapter-dialog.component.css']
})
export class UnlockChapterDialogComponent implements OnInit {
  showfreeCount:boolean = false;
  showCoins:boolean = false;
  showRedeem:boolean = false;
  showSubscription:boolean = false;
  coins:any;
  showCoupon:boolean = false;
  copyCouponCode: any;
  constructor(private router: Router, public dialog: MatDialog, public dialogRef: MatDialogRef<UnlockChapterDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any, public selfLearnService:SelfLearnService) { }

  ngOnInit(): void {
    switch (this.data.type) {
      case 'freeCount':
        this.showfreeCount = true;
        break;
      case 'isCoinsToRedeem':
        this.showCoins = true;
        break;
      case 'isToSubcribe':
        this.showSubscription = true;
        break;
      default:
        break;
    }
      if(this.data.type == 'freeCount'){
      }
  }

  navigateToChapterPage(){
    switch (this.data.type) {
      case 'freeCount':
        this.redeemAndUnlockChapter()
        break;
      case 'isCoinsToRedeem':
        this.redeemAndUnlockChapter()
        break;
      default:
        break;
    }
   
  }

  redeemAndUnlockChapter(){
    this.selfLearnService.redeemAndUnlockChapter(this.data.payload).subscribe((resp:any) => {
      if(this.data.type == 'freeCount'){this.redirectToTopicPage();return}
      this.saveCoinsSummary(this.data?.chapter)
    });
  }

  saveCoinsSummary(chapter:any){
    const payload = this.constructJsonForsaveCoinsSummary(chapter);
    this.selfLearnService.saveRedeemSummary(payload).subscribe((resp: any) => {
      this.getCoinsDetails();
    });
  }

  constructJsonForsaveCoinsSummary(chapter:any){
    const payload = {
      coins: chapter?.redeemCoinsCount,
      days: 0,
      discountApplied: false,
      name: 'unlock_chapter',
      percentage: 0,
      userId: this.selfLearnService.getUserInfo().userId,
    };
    return payload;
  }

  getCoinsDetails(){
    this.selfLearnService.getCoinsDetails().subscribe((resp:any) => {
      this.coins = resp?.totActiveCoins;
      this.showCoins = false;
      this.showRedeem = true;
    });
  }

  redirectToTopicPage(){
    this.dialogRef.close(true);
    localStorage.setItem("chapterId", this.data?.chapter?.chapterId);
    localStorage.setItem("chapterName", this.data?.chapter?.chapterName);
    this.router.navigateByUrl("selfLearn-V2/chapter");
  }

  checkPreRrequisiteAndNavigate(){
    if(this.showfreeCount){
      this.redeemAndUnlockChapter()
    } else if(this.showRedeem){
      this.redirectToTopicPage()
    }else{
      this.dialogRef.close(true);
    }
  }

  copyCoupon(coupon: any) {
    this.showCoupon = !this.showCoupon;
    this.copyCouponCode = coupon;
    navigator.clipboard.writeText(coupon);
  }

  navigateToSubscriptions(){
    localStorage.setItem('SelectedTab', 'subscriptionPackages');
    this.router.navigate(["/subscription/subscriptionPackages"])
    this.dialogRef.close(true);
  }

}
